import { FC, ReactNode } from 'react'

interface FormFieldProps {
  children: ReactNode
  label: string
  error?: string
  requiredField?: boolean
}

export const FormField: FC<FormFieldProps> = ({ label, children, requiredField = false, error }) => {
  return (
    <div className="flex flex-col text-left">
      <label className="text-neutral-darker text-sm">
        {label}
        {requiredField && <span className="text-error">*</span>}
      </label>
      {children}
      <div className="relative">
        {error && (
          <div className="text-error bg-error-very-light absolute top-1 left-0 z-10 px-1 text-sm/4">{error}</div>
        )}
      </div>
    </div>
  )
}
